import { ITabInternal } from "../../interfaces";

export const GaTab = ({title, isActive, onClick} : ITabInternal) => {
    return (
        <button className={`ga-segmented-control__button ${isActive ? "ga-segmented-control__button--selected" : ""}`} onClick={onClick} title={title}>{title}</button>
    );
}
